// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"238":"c3d96ad3","787":"1ff54ee4"}[chunkId] + ".chunk.js";
};